import {ReactNode} from 'react';
import {useParams} from 'react-router-dom';
import {Navigate} from 'react-router';
import {ROUTE_PATHS} from '@di-shared/routes';

export interface LicensePlateNumberGuardProps {
  children(licensePlateNumber: string): ReactNode;
}

function LicensePlateNumberGuard({children}: LicensePlateNumberGuardProps): JSX.Element {
  const params = useParams();

  if (!params.licensePlateNumber) {
    return (
      <Navigate
        to={ROUTE_PATHS.ERROR.getFullPath()}
        replace
      />
    );
  }

  return <>{children(params.licensePlateNumber)}</>;
}

export default LicensePlateNumberGuard;
